import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* ==================================================
            TOP FOOTER
            ================================================== */}

        <div className="footer-top">

          {/* BRAND */}

          <div className="footer-brand">

            <a href="/" className="footer-logo">
              <img
                src="/logo/strides extended logo.JPG"
                alt="Strides Energy & Maritime"
              />
            </a>

            <p>
              Delivering dependable energy and maritime
              solutions through expertise, innovation and
              operational excellence.
            </p>

            {/* SOCIAL MEDIA */}

            <div className="footer-social">

              <span className="footer-social-title">
                FOLLOW US
              </span>

              <div className="footer-social-links">

                <a
                  href="#"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon linkedIn"
                >
                  in
                </a>

                <a
                  href="#"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon facebook"
                >
                  f
                </a>

                <a
                  href="#"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon instagram"
                >
                  ◌
                </a>

                <a
                  href="#"
                  aria-label="X"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon x"
                >
                  X
                </a>

                <a
                  href="#"
                  aria-label="YouTube"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon youtube"
                >
                  ▶
                </a>

              </div>

            </div>

          </div>


          {/* COMPANY */}

          <div className="footer-column">

            <h3>Company</h3>

            <a href="/who-we-are">About Us</a>

            <a href="/what-we-do">What We Do</a>

            <a href="/management">
              Management Team
            </a>

            <a href="/subsidiaries">
              Subsidiaries & Affiliates
            </a>

            <a href="/careers">
              Careers
            </a>

          </div>


          {/* EXPLORE */}

          <div className="footer-column">

            <h3>Explore</h3>

            <a href="#services">
              Services
            </a>

            <a href="/projects">
              Projects
            </a>

            <a href="/vessels">
              Vessels
            </a>

            <a href="/community/hse">
              Community
            </a>

            <a href="#news">
              News & Insights
            </a>

          </div>


          {/* CONTACT */}

          <div className="footer-column footer-contact">

            <h3>Contact</h3>

            <a href="/contact">
              Get In Touch
            </a>

            <p>
              Strides Energy & Maritime Limited
            </p>

            <a href="mailto:info@stridesenergy.com">
              info@stridesenergy.com
            </a>

          </div>

        </div>


        {/* ==================================================
            DIVIDER
            ================================================== */}

        <div className="footer-divider"></div>


        {/* ==================================================
            BOTTOM
            ================================================== */}

        <div className="footer-bottom">

          <p>
            © {new Date().getFullYear()} Strides Energy &
            Maritime Limited. All rights reserved.
          </p>

          <div className="footer-bottom-links">

            <a href="#about">
              Privacy Policy
            </a>

            <a href="#about">
              Terms & Conditions
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
}

export default Footer;